import React, { Component } from 'react';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

class ModalPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    this.props.handleClose()
  }
  render() {
    return (
      <MDBContainer>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle} centered   >
          <MDBModalHeader className="default-color gothamBlack m-1 white-text" toggle={this.toggle}>{this.props.title}</MDBModalHeader>
          <MDBModalBody>
            {this.props.body}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn size='sm' className="btn-dark-green"  onClick={this.toggle}>Close</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}
export default ModalPopup;


// WEBPACK FOOTER //
// ./src/Components/Popups/ModalPopup.jsx